import React from 'react'
import Modal from '../../../components/MyModal/MyModal'
import ModalBody from './ModalBody'
// import { useSelector } from 'react-redux'

const BarrierErrorModal = ({ modal, toggle, error, onRetryVerification, successMessage }) => {
  // const location = useSelector((state) => state.location.location)

  return (
    <Modal
      toggle={toggle}
      modal={modal}
      closeButton={error === ''}
      body={<ModalBody error={error} toggle={toggle} onRetryVerification={onRetryVerification} successMessage={successMessage} />}
      setHeight={error === '' ? '24vh' : null}
    />
  )
}

export default BarrierErrorModal
